import { collection, addDoc, Timestamp, getDocs, query, where, orderBy, DocumentData, QueryDocumentSnapshot, doc, deleteDoc } from 'firebase/firestore';
import { db } from '../config/firebase.config';

export interface PartialLead {
  email: string;
  firstName: string;
  step: number;
  timestamp: Date;
  convertedToUser?: boolean;
  marketingSource?: string;
}

export interface Lead extends PartialLead {
  id: string;
}

export class LeadService {
  private static COLLECTION = 'leads';

  static async saveLead(leadData: PartialLead) {
    try {
      const leadRef = await addDoc(collection(db, this.COLLECTION), {
        ...leadData,
        timestamp: Timestamp.fromDate(leadData.timestamp),
        convertedToUser: false
      });
      return leadRef.id;
    } catch (error) {
      console.error('Error saving lead:', error);
      throw error;
    }
  }

  static async getLeads(): Promise<Lead[]> {
    try {
      const q = query(
        collection(db, this.COLLECTION),
        orderBy('timestamp', 'desc')
      );
      
      const querySnapshot = await getDocs(q);
      return querySnapshot.docs.map(this.convertToLead);
    } catch (error) {
      console.error('Error getting leads:', error);
      throw error;
    }
  }

  static async getUnconvertedLeads(): Promise<Lead[]> {
    try {
      const q = query(
        collection(db, this.COLLECTION),
        where('convertedToUser', '==', false),
        orderBy('timestamp', 'desc')
      );
      
      const querySnapshot = await getDocs(q);
      return querySnapshot.docs.map(this.convertToLead);
    } catch (error) {
      console.error('Error getting unconverted leads:', error);
      throw error;
    }
  }

  private static convertToLead(doc: QueryDocumentSnapshot<DocumentData>): Lead {
    const data = doc.data();
    return {
      id: doc.id,
      email: data.email,
      firstName: data.firstName,
      step: data.step,
      timestamp: (data.timestamp as Timestamp).toDate(),
      convertedToUser: data.convertedToUser,
      marketingSource: data.marketingSource
    };
  }

  static async deleteLead(id: string): Promise<void> {
    try {
      await deleteDoc(doc(db, this.COLLECTION, id));
    } catch (error) {
      console.error('Error deleting lead:', error);
      throw error;
    }
  }
}
